/**
 * Kauffman Expandable Block Component
 */
import { Component } from 'js-component-framework';

/**
 * Expandable Block Class
 */
export default class Expandable extends Component {
  /**
   * Start the component
   */
  constructor(config) {
    super(config);
    this.init();
  }

  /**
   * Function that fires when component loads.
   */
  init() {
    const {
      heading,
    } = this.children;

    heading.addEventListener('click', () => {
      const expanded = heading.getAttribute('aria-expanded');

      if ('false' === expanded) {
        heading.setAttribute('aria-expanded', 'true');
      } else {
        heading.setAttribute('aria-expanded', 'false');
      }
    });
  }
}
